import EmbassyForm from "./EmbassyForm.component";

export default EmbassyForm;